<template>
  <div>
    <div class="wrapper">
   
      <div class="charger">
        <div class="box">
          <div class="wave wave-one"></div>
          <div class="wave wave-two"></div>
          <div class="wave wave-three"></div>
          <div class="shade"></div>
          <div class="bubble x1"></div>
          <div class="bubble x2"></div>
          <div class="bubble x3"></div>
          <div class="bubble x8"></div>
          <div class="bubble x9"></div>
          <div class="bubble x10"></div>
          <div class="bubble x4"></div>
          <div class="bubble x5"></div>
          <div class="bubble x6"></div>
          <div class="bubble x7"></div>
          <div class="bubble x1"></div>
          <div class="bubble x2"></div>
          <div class="bubble x3"></div>
          <div class="bubble x8"></div>
          <div class="bubble x9"></div>
          <div class="bubble x10"></div>
          <div class='title'>در حال ضبط صدا</div>
        </div>
      </div>
    </div>
<!-- <button class="Rec">Recording</button> -->
	
  </div>
</template>

<script>
  export default {

  }

</script>

<style>
.Rec {
	width: 35px;
	height: 35px;
	font-size: 0;

	border: 0;
	border-radius: 35px;
	margin: 18px;

}
  .wrapper {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }



  .charger {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: 160px;

    background: white;
  

  }

  .box {

    width: 100%;
    height: 160px;
    background: white;
    border-radius: 25px;
    position: relative;
    overflow: hidden;
    transform: rotate(180deg);
  }

  .wave {
    opacity: 0.4;
    position: absolute;
    bottom: 22%;
    left: 39%;
    background: linear-gradient(to right, #ff00cc, #333399);
    width: 700px;
    height: 700px;
    transform-origin: 50% 48%;
    border-radius: 40%;
    margin-left: -250px;
    margin-top: -250px;
    animation: 3000ms linear infinite reverse drift;
  }

  .wave-three {
    animation: 5000ms linear infinite drift;

    opacity: 0.5;
  }

  .wave .wave-two {
    animation: 7000ms linear infinite backwards drift;
    opacity: .2;
  }

  .shade {
    display: none;
    width: 25px;
    height: 70px;
    background: #fc67fa;
    border-radius: 25px;
    position: relative;
    left: 85%;
    top: 10%;
  }

  .x1 {
    animation: animateBubble 10s linear infinite, sideWays 2s ease-in-out infinite alternate;
    left: -5%;
    top: 5%;
    transform: scale(0.1);
  }

  .x2 {
    animation: animateBubble 15s linear infinite, sideWays 5s ease-in-out infinite alternate;
    left: 5%;
    top: 4%;
    transform: scale(0.09);
  }

  .x3 {
    animation: animateBubble 12s linear infinite, sideWays 2s ease-in-out infinite alternate;
    left: 5%;
    top: 10%;
    transform: scale(0.09);
  }

  .x4 {
    animation: animateBubble 16s linear infinite, sideWays 3s ease-in-out infinite alternate;
    left: 5%;
    top: 8%;
    transform: scale(0.09);
  }

  .x5 {
    animation: animateBubble 14s linear infinite, sideWays 6s ease-in-out infinite alternate;
    left: 5%;
    top: 8%;
    transform: scale(0.09);
  }

  .x6 {
    animation: animateBubble 17s linear infinite, sideWays 3s ease-in-out infinite alternate;
    left: 5%;
    top: 8%;
    transform: scale(0.09);
  }

  .x7 {
    animation: animateBubble 16s linear infinite, sideWays 5s ease-in-out infinite alternate;
    left: 5%;
    top: 8%;
    ;
    transform: scale(0.09);
  }

  .x8 {
    animation: animateBubble 19s linear infinite, sideWays 2s ease-in-out infinite alternate;
    left: 5%;
    top: 8%;
    ;
    transform: scale(0.09);
  }

  .x9 {
    animation: animateBubble 18s linear infinite, sideWays 4s ease-in-out infinite alternate;
    left: 5%;
    top: 8%;
    ;
    transform: scale(0.09);
  }

  .x10 {
    animation: animateBubble 20s linear infinite, sideWays 5s ease-in-out infinite alternate;
    left: 5%;
    top: 8%;
    ;
    transform: scale(0.09);
  }

  .bubble {
    border-radius: 50%;
    height: 200px;
    position: absolute;
    width: 200px;
  }

  .bubble:after {
    background: linear-gradient(#ff00cc, #333399);
    border-radius: 50%;
    content: "";
    height: 180px;
    left: 10px;
    position: absolute;
    width: 180px;
  }

  .title {
    position: absolute;

    transform: rotate(180deg);
    width: 100%;

    text-align: center;
    color: white;

    font-size: 20px;
    text-shadow: 0 1px 0 rgba(black, .1);
    text-indent: .3em;
  }

  @keyframes drift {
    from {
      transform: rotate(0deg);
    }

    from {
      transform: rotate(360deg);
    }
  }

  @keyframes animateBubble {
    0% {
      margin-top: 10px;
    }

    100% {
      margin-top: 900%;
    }
  }

  @keyframes sideWays {
    0% {
      margin-left: 0px;
    }

    100% {
      margin-left: 50px;
    }
  }

</style>
